import { IUserGroup } from 'models/userGroup.model';

interface SelectedUserRoleDisplayItem {
  id: string;
  label: string;
}

const formatRoleLabel = ({
  roleName,
  groupName,
  hasDuplicates,
}: {
  roleName: string;
  groupName: string;
  hasDuplicates: boolean;
}) => {
  if (!hasDuplicates) {
    return roleName;
  }

  return `${roleName} (${groupName})`;
};

export const getSelectedUserRoleDisplayItems = ({
  selectedRoleIds,
  userGroups,
}: {
  selectedRoleIds: string[];
  userGroups: IUserGroup[];
}): SelectedUserRoleDisplayItem[] => {
  const selectedRoles = selectedRoleIds
    .map((id) => {
      for (const group of userGroups) {
        const role = group.roles.find((item) => item.id === id);

        if (role) {
          return {
            id,
            roleName: role.name,
            groupName: group.name,
          };
        }
      }

      return null;
    })
    .filter((role) => role !== null);

  const duplicatedRoleNames = selectedRoles.reduce<Record<string, number>>(
    (acc, role) => {
      acc[role.roleName] = (acc[role.roleName] ?? 0) + 1;

      return acc;
    },
    {},
  );

  return selectedRoles.map((role) => ({
    id: role.id,
    label: formatRoleLabel({
      roleName: role.roleName,
      groupName: role.groupName,
      hasDuplicates: duplicatedRoleNames[role.roleName] > 1,
    }),
  }));
};

export const getSelectedUserRolesReadonlyValue = ({
  selectedRoleIds,
  userGroups,
}: {
  selectedRoleIds: string[];
  userGroups: IUserGroup[];
}) =>
  getSelectedUserRoleDisplayItems({ selectedRoleIds, userGroups })
    .map((role) => role.label)
    .join(', ');
